import useErrorHandler from './useErrorHandler'
export { useMinimalErrorHandler } from './useErrorHandler'
export default useErrorHandler
